var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-home"},[_c('ul',_vm._l((_vm.paths),function(path){return _c('li',{key:path},[_c('a',{attrs:{"href":path + '?serverId=' + _vm.serverId}},[_vm._v(_vm._s(path))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }